import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Divider,
  Button,
  Card,
  CardContent,
  TextField,
  CardHeader,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import React, { Component } from 'react';
import SearchRecords from './SearchRecords';
import RequestChart from 'src/components/pages/vaccination/dashboard/RequestChart';
import StatusCount from 'src/components/pages/vaccination/dashboard/StatusCount';
import masterStatus from 'src/models/medicine';
import Traffic from 'src/components/pages/vaccination/dashboard/TrafficByType';
import { _axios } from 'src/plugins/axios';
import moment from 'moment';
import * as _ from 'lodash';
import theme from 'src/theme';
import Report from '@mui/icons-material/Report';
import Beenhere from '@mui/icons-material/Beenhere';
import Cancel from '@mui/icons-material/Cancel';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import OfflinePin from '@mui/icons-material/OfflinePin';
import commonService from 'src/service/common';
import goodalipi from 'src/plugins/goodalipi';
import Count from 'src/components/pages/ahc/ahcEmployees/count';
import { Pie, Bar } from 'react-chartjs-2';
const masterStatusCount = JSON.parse(JSON.stringify(masterStatus));
import axios from 'axios';

class MedicineProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      providerWiseData: ['1mg', 'Pharmeasy', 'Other'],
      officeCampusRequests: [],
      hospitalRequests: [],
      masterDataCountItems: [],
      gender_age: null,
      deliveryType: null,
      periodWiseCount: null,
      periodWiseCount: {},
      isBrandWiseRes: false,
      label: 'Medicines provider wise',
      backgroundColor: [ '#D35400', '#58D68D', '#D4E6F1'],
      hoverBackgroundColor: [
        '#501800',
        '#4B5000',
        '#175000',
        '#003350',
        '#35014F'
      ],
      data: null,
      dataC: null,
      avgDiscount: [
        'Provider Name',
        'No. of Requests',
        'No. of Users',
        'Total Discount',
        'Avarage Discount'
      ],
      brandWiseDiscount: [],
      avgPharmacyClaim: 0,
      avgSLA: 0,
      totalOrders: 0,
      CSAT: 5,
      top50Meds: [],
      isTop50MedsRes: false,
      page: 0,
      limit: 10
    };
    this.DeliveryType = React.createRef();
    this.ageWiseRef = React.createRef();
  }
  getProviderWiseData() {
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "BrandWiseSplit"
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken()
          }
        }
      )
      .then((res) => {
        console.log(res.data.result[0].providerName)
        if (res.data.isSuccess) {
          let pieData = {
            labels: [
              res.data.result[0].providerName,
              res.data.result[1].providerName,
              res.data.result[2].providerName
            ],
            datasets: [
              {
                label: this.state.label,
                backgroundColor: this.state.backgroundColor,
                hoverBackgroundColor: this.state.hoverBackgroundColor,
                data: [
                  res.data.result[0].Amount,
                  res.data.result[1].Amount,
                  res.data.result[2].Amount
                ]
              }
            ]
          };
          let pieDataC = {
            labels: [
              res.data.result[0].providerName,
              res.data.result[1].providerName,
              res.data.result[2].providerName
            ],
            datasets: [
              {
                label: this.state.label,
                backgroundColor: this.state.backgroundColor,
                hoverBackgroundColor: this.state.hoverBackgroundColor,
                data: [
                  res.data.result[0].countt,
                  res.data.result[1].countt,
                  res.data.result[2].countt
                ]
              }
            ]
          };
          console.log('pieData', pieData);
          this.setState({ data: pieData });
          this.setState({ dataC: pieDataC });
        }
      })
      .catch((err) => {
        console.log('good', goodalipi.get('user').baseProfileData.entityId);
        console.log(err);
      });
  }

  getBrandWiseAvgDiscount() {
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "BrandwiseAvgDiscount"
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken()
          }
        }
      )
      .then((res) => {
        if (res.data.isSuccess)
        this.setState({ isBrandWiseRes: true });
          this.setState({ brandWiseDiscount: res.data.result});
        // console.log('res',res.data.result)
        // console.log('brand', this.state.brandWiseDiscount)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  avgPharmacyClaim() {
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "AvgPharmacyClaimSize"
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
      {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      }
    )
      .then((res) => {
        if (res.data.isSuccess) {
          this.setState({
            avgPharmacyClaim: res.data.result[0].AOV_MAWallet.toFixed(2)
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  top50Meds() {
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "TopMedicinesOrdered",
      pageSize: this.state.limit,
      startIndex: this.state.page * this.state.limit
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
      {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      }
    )
      .then((res) => {
        if (res.data.isSuccess) {
          this.setState({ isTop50MedsRes: true });
          this.setState({ top50Meds: res.data.result });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  avgSLA() {
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "TargetSLA"
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
      {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      }
    )
    
      .then((res) => {
        if (res.data.isSuccess) {
          this.setState({totalOrders: res.data.result.length}) 
          let inSlaCount = 0
          res.data.result.map(item=>{
            if(item.SLA == "In SLA") inSlaCount++
          })
          this.setState({
            avgSLA: (inSlaCount/res.data.result.length).toFixed(2)
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  csat(){
    let today = new Date()
    let startDate =  new Date();
    startDate.setMonth(startDate.getMonth()-1)
    let options={
      fromDate: startDate.toISOString().slice(0,10),
      toDate: today.toISOString().slice(0,10),
      entityID: goodalipi.get('user').baseProfileData.entityId,
      query: "PharmacyCSAT"
    }
    _axios
      .post(
        '/queries/getDataFromQueries',
        options,
      {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      }
    )
      .then((res) => {
        if (res.data.isSuccess) {
          let csatCount = 0, csat=0
          res.data.result.map(item=>{
            if(item.Overallrating>0) {
              csatCount++;
              csat+=parseInt(item.Overallrating);
            }
          })
          this.setState({
            CSAT: ( csat/csatCount).toFixed(2)
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getProviderWiseData();
    this.getBrandWiseAvgDiscount();
    this.avgPharmacyClaim();
    this.top50Meds();
    this.avgSLA();
    this.csat();
  }

  handleLimitChange = async (event) => {
    await this.setState({ limit: event.target.value });
    this.top50Meds();
  };

  handlePageChange = async (event, newPage) => {
    await this.setState({ page: newPage });
    this.top50Meds();
  };
  render() {
    return (
      <>
        <Helmet>
          <title>Medicine | Provider</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container alignItems="stretch" spacing={2}>
              <Grid item container lg={8} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <Grid
                    marginTop="0%"
                    marginBottom="5%"
                    container
                    direction="row"
                    justifyContent="space-around"
                    spacing={3}
                  >
                    <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                      <Count
                        status={{
                          statusName: 'Pharmacy Claim',
                          status: 'Avarage Pharmacy Claim',
                          bgColor: '#fff',
                          totalCount: this.state.avgPharmacyClaim,
                          statusId: [32],
                          darkColor: '#40d9c4'
                        }}
                        loading={this.state.avgPharmacyClaim == 0}
                        server={true}
                      ></Count>
                    </Grid>
                    <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                      <Count
                        status={{
                          statusName: 'Pharmacy Claim',
                          status: 'Delivered in SLA | Total order',
                          bgColor: '#fff',
                          totalCount: `${this.state.avgSLA} | ${this.state.totalOrders}`,
                          statusId: [32],
                          darkColor: '#40d9c4'
                        }}
                        loading={this.state.avgSLA == 0}
                        server={true}
                      ></Count>
                    </Grid>
                    <Grid item lg={4} sm={6} xl={3} xs={12} md={4}>
                      <Count
                        status={{
                          statusName: 'Pharmacy Claim',
                          status: 'CSAT',
                          bgColor: '#fff',
                          totalCount: this.state.CSAT,
                          statusId: [32],
                          darkColor: '#40d9c4'
                        }}
                        loading={this.state.CSAT == 5}
                        server={true}
                      ></Count>
                    </Grid>
                  </Grid>
                  <hr />
                  <b style={{ marginLeft: '40%' }}>Top 50 Meds ordered</b>
                  {!this.state.isTop50MedsRes ? (
                    <CircularProgress sx={{ margin: '35%' }} size={100} />
                  ) : (
                    <TableContainer>
                      <Table
                        stickyHeader
                        aria-label="Top 50 Meds ordered"
                        id="employee-list"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Medicine</TableCell>
                            <TableCell>Quantity</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.top50Meds.map((e) => (
                            <TableRow>
                              <TableCell>{e.PI_itemName ? e.PI_itemName: 'NA'}</TableCell>
                              <TableCell>{e.totalquantity ? e.totalquantity: 'NA'}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        component="div"
                        count="50"
                        onPageChange={this.handlePageChange}
                        onRowsPerPageChange={this.handleLimitChange}
                        page={this.state.page}
                        rowsPerPage={this.state.limit}
                        rowsPerPageOptions={[5, 10, 25]}
                      />
                    </TableContainer>
                  )}
                </Card>
              </Grid>
              <Grid item container lg={4} xs={12}>
                <Card
                  col={2}
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    pt: 2,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)',
                    direction: 'column'
                  }}
                >
                  <CardHeader title="Brand wise amount" />
                  {!this.state.data ? (
                    <CircularProgress
                      sx={{
                        margin: '25%'
                      }}
                      size={90}
                    />
                  ) : (
                    <CardContent>
                      <Pie
                        data={this.state.data}
                        options={{
                          title: {
                            display: true,
                            text: 'Brand wise Amount',
                            fontSize: 20
                          },
                          legend: {
                            display: true,
                            position: 'right'
                          }
                        }}
                      />
                    </CardContent>
                  )}

                  <CardHeader title="Brand wise count" />
                  {!this.state.dataC ? (
                    <CircularProgress
                      sx={{
                        margin: '25%'
                      }}
                      size={90}
                    />
                  ) : (
                    <CardContent>
                      <Pie
                        data={this.state.dataC}
                        options={{
                          title: {
                            display: true,
                            text: 'Brand wise count',
                            fontSize: 20
                          },
                          legend: {
                            display: true,
                            position: 'right'
                          }
                        }}
                      />
                    </CardContent>
                  )}
                </Card>

              </Grid>
              <Grid item container lg={8} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <b style={{ marginLeft: '35%', marginTop: '5%' }} >Brand Wise Avarage Discount</b>
                  {!this.state.isBrandWiseRes ? (
                          <CircularProgress
                          sx={{
                            margin: '35%'
                          }}
                          size={90}
                        /> 
                        ) : (
                  <TableContainer>
                    <Table
                      stickyHeader
                      aria-label="Avarage Discount"
                      id="employee-list"
                    >
                      <TableHead>
                        <TableRow>
                          {this.state.avgDiscount.map((e) => (
                            <TableCell>{e}</TableCell>
                          ))}
                        </TableRow>
                        </TableHead>
                          <TableBody>
                        {this.state.brandWiseDiscount.map((e) => (
                          <TableRow>
                            <TableCell>{e.providerName ? e.providerName: 'NA'}</TableCell>
                            <TableCell>{e.R_Id_countt ? e.R_Id_countt: 'NA'}</TableCell>
                            <TableCell>{e.users_countt? e.users_countt: 'NA'}</TableCell>
                            <TableCell>{e.TotalDiscount? e.TotalDiscount : 'NA'}</TableCell>
                            <TableCell>{e.AverageDiscount ? e.AverageDiscount : 'NA'}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                        
                    </Table>
                  </TableContainer>)}
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </>
    );
  }
}

export default MedicineProvider;
